import { render, staticRenderFns } from "./ReportOrderSumsPerDistributorPage.vue?vue&type=template&id=a6a7b25e&scoped=true"
import script from "./ReportOrderSumsPerDistributorPage.vue?vue&type=script&lang=js"
export * from "./ReportOrderSumsPerDistributorPage.vue?vue&type=script&lang=js"
import style0 from "./ReportOrderSumsPerDistributorPage.vue?vue&type=style&index=0&id=a6a7b25e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a7b25e",
  null
  
)

export default component.exports